import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Convocation } from '../model/convocation';
import { EcawinEvent } from '../model/ecawin-event';

@Injectable({
  providedIn: 'root',
})
export class ConvocationService {
  constructor(private http: HttpClient) {}

  getMyConvocations(max: number) {
    let maxParam = '';
    if (max) {
      maxParam = '?max=' + max;
    }
    return this.http
      .get('/api/convocations/my' + maxParam)
      .pipe(map((value: any[]) => value.map((t) => new Convocation(t))));
  }

  getMyPermanences(max: number) {
    let maxParam = '';
    if (max) {
      maxParam = '?max=' + max;
    }
    return this.http
      .get('/api/convocations/myPermanences' + maxParam)
      .pipe(map((value: any[]) => value));
  }

  absence(convocation: Convocation, reason: string) {
    return this.http
      .post('/api/convocations/absence/' + convocation.id, reason)
      .pipe(map((value: any) => new Convocation(value)));
  }

  findCoursAndExercices() {
    return this.http
      .get('/api/admin/convocations/ecawinevent')
      .pipe(
        map((value: any[]) =>
          value.map((t) => new EcawinEvent(t.event, t.convocationCount))
        )
      );
  }

  loadEcawinEvent(c: EcawinEvent) {
    return this.http
      .get('/api/admin/convocations/ecawinevent/' + c.id)
      .pipe(map((value) => new EcawinEvent(value)));
  }
}
